import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public saveData(key: string, data: any): void {
    const stringData = JSON.stringify(data);
    localStorage.setItem(key, stringData);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getData(key: string): any {
    try {
      const stringData = localStorage.getItem(key);
      return JSON.parse(stringData || '');
    } catch {
      return null;
    }
  }

  public clearData(key: string): void {
    localStorage.removeItem(key);
  }

  public clearAll(): void {
    localStorage.clear();
  }
}

export const localStorageKeys = {
  callAttributes: 'callAttributes',
  lastUsedOutboundService: 'lastUsedOutboundService',
  version: 'version',
};
